import { render, staticRenderFns } from "./Page-Purchase.vue?vue&type=template&id=da4ea1dc&scoped=true"
import script from "./Page-Purchase.vue?vue&type=script&lang=js"
export * from "./Page-Purchase.vue?vue&type=script&lang=js"
import style0 from "./Page-Purchase.vue?vue&type=style&index=0&id=da4ea1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4ea1dc",
  null
  
)

export default component.exports